import * as gfunctions from '../../../js/generalFunctions';

CCL.atcDining = {
  autoload: [
    ['initialDataLoad', $('#diningAtcModal').length > 0]
  ],

  initialDataLoad() {
    $('body').on('click', '.dining-atc-modal-open-button', (e) => {
      const prodId = $(e.currentTarget).data('productcode');
      this.loadDiningJsonData(prodId);
    });
  },

  initialValuesTimeDay() {
    const selectDay = $('#select-day');
    const selectTime = $('#select-time');
    const dayValue = selectDay.find('> span').text();
    const timeValue = selectTime.find('> span').text();

    setTimeout(() => {
      selectDay.attr('aria-label', `Select day: ${dayValue} selected`);
      if ($('.select-cabana').length) {
        selectTime.attr('aria-label', `Select Cabana: ${timeValue} selected`);
      } else {
        selectTime.attr('aria-label', `Select time: ${timeValue} selected`);
      }
    }, 200);
  },

  loadDiningJsonData(prodId) {
    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let ajaxType = '';
    const dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/dining-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    gfunctions.showLoader();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      this.loadHtmlTamplate(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  loadHtmlTamplate(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/dining-atc-modal/dining-atc-modal.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('#dynamicDiningAtcModal').empty().append(html);
      gfunctions.showModal('diningAtcModal');
      CCL.Dining.priceShow();
      CCL.Dining.dropdownSelect();
      this.modalEvents();
      this.initialValuesTimeDay();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },

  modalEvents() {
    const modalEl = $('#diningAtcModal');
    const firstFocusable = gfunctions.getFocusableElements(modalEl);
    const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');

    firstFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        lastFocusable.focus();
      }
    });
    lastFocusable.on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-dining-atc-modal/dining-atc-modal.js